export default function SectionSkeleton({
  className = "",
  showTitle = true,
  showDescription = false,
}) {
  return (
    <section className={`mx-auto w-full animate-pulse ${className}`}>
      <div className="container mx-auto px-4">
        {showTitle && (
          <div className="mb-6 flex flex-col gap-2">
            <div className="h-8 w-64 rounded bg-gray-200"></div>
            {showDescription && (
              <div className="h-4 w-96 rounded bg-gray-200"></div>
            )}
          </div>
        )}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="h-48 rounded-lg bg-gray-200"></div>
          ))}
        </div>
      </div>
    </section>
  );
}

